import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const baseUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
        ? "http://dev.velmart.sv/"
        : "https://velmart.digiants.agency/";

// export const baseUrl = "http://dev.velmart.sv/";

// function getCookieValue(cookieName) {
//     const cookies = document.cookie.split("; ");
//     for (let i = 0; i < cookies.length; i++) {
//         const [name, value] = cookies[i].split("=");
//         if (name === cookieName) {
//             return decodeURIComponent(value);
//         }
//     }
//     return null;
// }

// const getToken = () => {
//     return JSON.parse(localStorage.getItem("token"));
// };

// const prepareAuthHeader = (headers, { getState, endpoint }) => {
//     // const CSRF_token = getCookieValue("X-XSRF-TOKEN");
//     // headers.set("X-XSRF-TOKEN", CSRF_token);
//     headers.set("Accept", "application/json");
//     headers.set("Content-Type", "application/json");
//     return headers;
// };

export const velmartAPI = createApi({
    reducerPath: "velmartAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            headers.set("X-XSRF-TOKEN", Cookies.get("XSRF-TOKEN"));
            return headers;
        },
        credentials: "include",
    }),
    endpoints: (builder) => ({
        getCookie: builder.query({
            query: () => ({ url: "sanctum/csrf-cookie", method: "get" }),
        }),
        ping: builder.query({
            query: () => ({ url: "api/ping", method: "get" }),
        }),
        getPage: builder.query({
            query: (url) => ({ url: "api/" + url, method: "get" }),
        }),
        sendForm: builder.mutation({
            query: ({ body, url, method = "POST" }) => ({
                url: "api/" + url,
                method: method,
                body: JSON.stringify(body),
                // headers: { "X-XSRF-TOKEN": getToken() },
            }),
        }),
        singIn: builder.mutation({
            query: ({ body, url, method = "POST", headers }) => ({
                url: url,
                method: method,
                body: JSON.stringify(body),
                headers: headers,
            }),
        }),
    }),
});

export const {
    usePingQuery,
    useGetPageQuery,
    useSendFormMutation,
    useLazyGetPageQuery,
    useSingInMutation,
    useGetCookieQuery,
} = velmartAPI;
